import { FC } from 'react'
import { Box } from '@/components/atoms/Grid'
import ResponsiveImage from '@/components/atoms/responsiveImage'
import ProductsSlider, {
  ProductSlide,
  SliderDirection
} from '@/components/organisms/productsSlider'
import { Config } from '@/core/config'

type MobileBrowserProps = {
  imageUrls: string[]
  onImageClick?: (offset: number) => void
  showBullets: boolean
  slidesToShow?: number
  slidesPerGroup?: number
  spaceBetween?: number
  arrowsTopPercent?: number
  width?: number
  height?: number
}

const MobileBrowser: FC<MobileBrowserProps> = ({
  imageUrls,
  onImageClick,
  showBullets,
  arrowsTopPercent,
  width = Config.imageSizes.xxl.width,
  height = Config.imageSizes.xxl.height,
  slidesToShow = 1,
  slidesPerGroup = 1,
  spaceBetween = 0
}) => {
  const onClick = (offset: number) => onImageClick && onImageClick(offset)
  return (
    <Box width="100%" data-testid="productDetailPopupSlider">
      <ProductsSlider
        showPagination={showBullets}
        slidesToShow={slidesToShow}
        slidesPerGroup={slidesPerGroup}
        sliderDirection={SliderDirection.horizontal}
        spaceBetween={spaceBetween}
        arrowsTopPercent={arrowsTopPercent}
      >
        {imageUrls &&
          imageUrls.map((url, offset) => (
            <ProductSlide key={offset}>
              <Box mb={showBullets ? 20 : 0}>
                <ResponsiveImage
                  width={width}
                  height={height}
                  imageUrl={url}
                  unoptimized={true}
                  onClick={() => onClick(offset)}
                />
              </Box>
            </ProductSlide>
          ))}
      </ProductsSlider>
    </Box>
  )
}

export default MobileBrowser
